import React from "react";
import { motion } from "framer-motion";
import { whyChoose } from "../Data";

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.2,
      ease: "easeOut",
    },
  },
};

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.18,
      delayChildren: 0.2,
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};

const iconVariant = {
  hidden: {
    opacity: 0,
    scale: 0.85,
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 1.2,
      ease: "easeOut",
    },
  },
};

const WhyChoose = ({heading}) => {
  return (
    <section className="why-choose-section container">
      <motion.p
        className="section-subheading"
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.2,
        }}
        variants={fadeUp}
      >
        Why Choose Us
      </motion.p>

      <motion.h2
        className="section-heading"
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.2,
        }}
        variants={fadeUp}
      >
        { heading || "Authentic Ayurvedic Treatments in Kutch, Gujarat" }
      </motion.h2>

      <motion.div
        className="why-choose-grid"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true,
          amount: 0.15,
        }}
      >
        {whyChoose.map((item, i) => (
          <motion.div
            className="why-choose-card"
            key={i}
            variants={cardVariant}
            whileHover={{
              y: -6,
            }}
            transition={{
              duration: 0.4,
            }}
          >
            <motion.div
              className="why-choose-icon-wrapper"
              variants={iconVariant}
            >
              <img
                src={item.icon}
                alt={`${item.title} | Dr. Jigar Gor's Ayurveda`}
              />
            </motion.div>

            <h3 className="card-heading">
              {item.title}
            </h3>

            <p className="section-text">
              {item.desc}
            </p>
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
};

export default WhyChoose;